module.exports = __webpack_public_path__ + "306bad0631d8f22a197fcb8d4facf4d7.jpg";